function updateValue(subscriptionValue: HTMLInputElement, value: string): void {
    const val = value;
    subscriptionValue.value = val;
    subscriptionValue.dispatchEvent(new window.Event('change', { bubbles: true }));
}

export default function initRadioSelect(selectContainer: HTMLElement, subscriptionValue: HTMLInputElement): void {
    const radioButtons = selectContainer.querySelectorAll(
        '.js-subscriptionRadioSelect'
    ) as NodeListOf<HTMLInputElement>;

    if (!radioButtons.length) return;

    radioButtons.forEach((button) => {
        button.addEventListener('change', (e) => {
            const target = e.target as HTMLInputElement;

            if (target.checked) {
                selectContainer.classList.remove('subscription-frequency--error');
                updateValue(subscriptionValue, target.value);
            }
        });

        if (button.checked) {
            updateValue(subscriptionValue, button.value);
        }
    });
}
